import { useCallback, useEffect, useState } from "react";
import { getAcorns } from "@/lib/api";

export const MILESTONES = [10, 25, 50];

const key = (p) => `pp_milestone_${p ? p.id : "guest"}`;

export const useAcornJar = (profile) => {
  const [jar, setJar] = useState({ total: 0, golden: 0 });
  const [milestone, setMilestone] = useState(null);

  const refresh = useCallback(async (celebrate = true) => {
    const j = await getAcorns(profile ? profile.id : "guest");
    setJar(j);
    const reached = MILESTONES.filter((m) => j.total >= m).pop();
    const seen = Number(localStorage.getItem(key(profile)) || 0);
    if (reached && reached > seen) {
      localStorage.setItem(key(profile), String(reached));
      if (celebrate) setMilestone(reached);
    }
  }, [profile]);

  useEffect(() => { refresh(false); }, [refresh]);

  return { jar, refresh, milestone, dismissMilestone: () => setMilestone(null) };
};
